module.exports = __webpack_public_path__ + "static/media/GettyImages-697155202.9588fd2f.mp4";